<template>
  <v-container>
    <v-card id="about" flat color="transparent">
      <v-row>
        <v-col
          cols="12"
          lg="6"
          xl="5"
          class="order-2 order-lg-1 d-flex justify-center align-center position-relative"
        >
          <div
            class="position-relative w-100 mb-16 mb-lg-0 mx-4 ml-lg-0 mr-lg-8 pa-lg-4"
          >
          <template v-if="smAndDown">
            <NuxtImg
              class="w-100 elevation-10 rounded-xl"
              src="/assets/home/faqs3.webp"
              alt="Preguntas frecuentes de Truster Cloud"
              loading="lazy"
            />
            <NuxtImg
              sizes="sm:150px md:800px lg:1000px xl:600px"
              class="position-absolute elevation-10 rounded-xl bouncing-img--vertical"
              style="top: 40%; right: 12px"
              src="/assets/home/faqs1.webp"
              alt="Imagen flotante de preguntas frecuentes de Truster Cloud"
              loading="lazy"
            />
            <NuxtImg
              sizes="sm:250px md:500px lg:400px xl:500px"
              class="position-absolute elevation-10 rounded-xl bouncing-img--horizontal ml-4 mb-4"
              style="left: 0; bottom: -60px"
              src="/assets/home/faqs2.webp"
              alt="Imagen flotante de preguntas frecuentes de Truster Cloud"
              loading="lazy"
            />
          </template>
             <NuxtImg
             v-else
              class="w-100 rounded-xl"
              src="/assets/home/1A.webp"
              alt=""
              loading="lazy"
            />
          </div>
        </v-col>
        <v-col cols="12" lg="6" xl="7" class="order-1 order-lg-2">
          <v-card-title class="text-h5 text-primary"
            >¿Aún tienes dudas? Resolvemos tus preguntas</v-card-title
          >
          <v-card-title class="text-h4 text-lg-h4"
            >Encuentra respuestas a las preguntas más comunes sobre Truster
            Cloud.
          </v-card-title>
          <v-expansion-panels class="mt-6 px-3 overflow-auto" rounded="lg">
            <v-expansion-panel
              v-for="(faq, index) in full ? faqs : faqs.slice(0, 5)"
              :key="index"
              class="mb-2"
            >
              <v-expansion-panel-title
                collapse-icon="$mdiMinus"
                expand-icon="$mdiPlus"
                class="text-h6"
              >
                {{ faq.title }}
              </v-expansion-panel-title>
              <v-expansion-panel-text v-if="typeof faq.value == 'string'">
                {{ faq.value }}
              </v-expansion-panel-text>
              <v-expansion-panel-text v-else>
                <v-list class="pa-0">
                  <v-list-item
                    v-for="(item, i) in faq.value"
                    :key="i"
                    density="compact"
                    class="px-0"
                    :title="`${i + 1 + ')'} ${item}`"
                  />
                </v-list>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script setup lang="ts">
import { useDisplay } from "vuetify";
const { smAndDown } = useDisplay();
const props = defineProps<{
  full?: boolean;
}>();
// import companyInfo from "~/data/companyInfo";
const faqs = [
  {
    title: "¿Qué es Truster Cloud y para qué tipo de negocio fue diseñado?",
    value:
      "Truster Cloud es un software de gestión integral (ERP) en la nube, diseñado específicamente para Pequeñas y Medianas Empresas (PYMES) en crecimiento. Su función es unificar y automatizar tus operaciones clave, como ventas, inventario, logística y administración; en una sola plataforma, para empresas que buscan un crecimiento eficiente, ordenado y sin límites.",
  },
  {
    title: "¿Es Truster Cloud personalizable para mi negocio?",
    value:
      "Entendemos que cada negocio es un mundo. Truster Cloud está construido sobre una base de estandarización de las mejores prácticas, pero con un alto grado de personalización. Podemos adaptar módulos y flujos de trabajo para que se ajusten a las particularidades de tu operación, asegurando que la herramienta trabaje para ti y no al revés.",
  },
  {
    title: "¿Truster Cloud se integra con mis herramientas actuales?",
    value:
      "Precisamente, Truster Cloud está diseñado para eliminar el caos de tener la información de tus clientes en un sitio, el inventario en otro y las ventas en un tercero, la gestión administrativa en otro sitio, etc. Nuestra plataforma integra todo, centralizando tus datos, te da reportes confiables en tiempo real y evita los errores y la pérdida de tiempo que genera el trabajo manual en distintas aplicaciones.",
  },
  {
    title: "¿Es difícil de implementar y usar el software?",
    value:
      "Esta es una de nuestras prioridades. Truster Cloud tiene una interfaz intuitiva y amigable. Pero lo más importante es que no te dejamos solo. Nuestro equipo te acompaña en todo el proceso de implementación, desde la migración de tus datos hasta la capacitación de tu personal, asegurando una transición suave y exitosa.",
  },
  {
    title: "¿Truster Cloud ofrece diferentes planes de precios?",
    value:
      "Si, tenemos una variedad de planes pensados en los escenarios mas demandados del mercado. Contacta con nuestro equipo y nuestros consultores te asesorarán según tus necesidades.",
  },
  {
    title:
      "¿Qué diferencia a Truster Cloud de otros sistemas de gestión en el mercado?",
    value:
      "Nuestra principal diferencia radica en nuestro origen: Truster Cloud es el resultado de más de 30 años de experiencia de Truster Consulting Group ayudando a empresas a escalar. No somos solo un software; somos una metodología de crecimiento probada, convertida en tecnología. Combinamos una herramienta potente con el acompañamiento y la visión estratégica que otros no ofrecen.",
  },
  {
    title:
      "¿En cuánto tiempo puedo empezar a ver resultados o mejoras en mi operación?",
    value:
      "Aunque varía según la complejidad de cada empresa, la mayoría de nuestros clientes comienzan a experimentar mejoras significativas —como reducción de errores manuales, mayor control de inventario y ahorro de tiempo en tareas administrativas— desde las primeras semanas de uso. El impacto completo en la escalabilidad se hace evidente a medida que todos tus procesos se consolidan en la plataforma.",
  },
  {
    title:
      "La información de mi empresa es muy sensible. ¿Qué tan seguro es Truster Cloud?",
    value:
      "La seguridad es un pilar no negociable para nosotros. Utilizamos servidores en la nube con los más altos estándares de seguridad, encriptación de datos y protocolos de acceso robustos para garantizar que tu información esté protegida, segura y disponible solo para los usuarios que tú autorices.",
  },
  {
    title: "¿Qué tipo de soporte técnico ofrecen una vez que soy cliente?",
    value:
      "Como tu partner tecnológico, ofrecemos soporte continuo a través de diferentes canales (email, teléfono, chat). Nuestro equipo de soporte no solo resuelve problemas técnicos, sino que también te asesora para que saques el máximo provecho de la herramienta y sigas optimizando tus procesos.",
  },
  {
    title: "¿Cómo funciona el modelo de precios? ¿Hay costos ocultos?",
    value:
      "Trabajamos con un modelo de suscripción mensual o anual que se ajusta al tamaño y las necesidades de tu empresa. Nuestro presupuesto es transparente: incluye el acceso a la plataforma, las actualizaciones y el soporte. Cualquier módulo o personalización adicional se discute y aprueba contigo de antemano.",
  },
  {
    title: "¿Necesito instalar algo en mis computadoras?",
    value:
      "No. Al ser un software 100% en la nube, no necesitas instalar nada. Puedes acceder a Truster Cloud de forma segura desde cualquier navegador web y en cualquier dispositivo (PC, laptop, tablet) con conexión a internet, dándote la flexibilidad de gestionar tu negocio desde donde estés.",
  },
];
</script>

<style lang="scss" scoped>
.insight {
  padding: 12px 0;
}
.ceo_img {
  filter: drop-shadow(0.5rem 0.5rem 1rem rgba(0, 0, 0, 0.3));
}
.slide-text {
  padding-top: 0;
}
.glass-card.glass-card.glass-card.glass-card.glass-card {
  /* Usamos variables de Vuetify para que se adapte al tema claro/oscuro */
  background-color: rgba(var(--v-theme-secondary), 0.2);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px); /* Para compatibilidad con Safari */
  border: 1px solid rgba(var(--v-theme-outline-rgb), 0.2);
}
.bouncing-img--horizontal {
  animation: bounce-horizontal 4s ease-in-out infinite;
}
.bouncing-img--vertical {
  animation: bounce 4s ease-in-out infinite;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15%);
  }
}
@keyframes bounce-horizontal {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(10%);
  }
}
</style>
